var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-area-manager-placeholder"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-wrapper text-center"},[_c('p',[_vm._v(_vm._s(_vm.placeholdText))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-picture"},[_c('img',{attrs:{"src":"/themes/custom/ef2_custom/images/placeholder-areamanager.png"}})])
}]

export { render, staticRenderFns }